﻿window.mcb.forms.validation = (function () {
  const _logger = window.mcb.utilities.createLogger("forms.validation");
  const failFast = !window.mcb.utilities.browser.getUrlBooleanParameter('forms-validation-fail-all');
  _logger.trace(failFast ? 'Fail fast enabled' : 'Fail fast disabled');

  let ValidationResult = function (isValid, message = null, data = null) {
    let _isValid = isValid;
    let _messages = [];
    let _data = [];
    if (!_isValid) {
      if (message !== null) {
        if (typeof message === "string") {
          _messages.push(message);
        }
        else {
          _messages = message;
        }

        if (data === null) {
          _data.push("");
        }
        else {
          _data.push(data);
        }
      }
    }

    return _ = {
      isValid: function () {
        return _isValid && _messages.length === 0;
      },
      messages: _messages,
      messagesData: _data,
      GetMessage: function (targetId, index = 0) {
        let message = "";
        if (index < _messages.length) {
          message = window.mcb.forms.data.getMessageFromToken(
            targetId,
            _messages[index]
          );

          let data = _data[index] ?? null;
          if (data === null) {
            data = "";
          }
          else if (Array.isArray(data) && data.length > 0) {
            let string = "";
            for (let i = 0; i < data.length; i++) {
              string += data[i];

              if (i + 2 === data.length) {
                string +=
                  " " +
                  window.mcb.forms.data.getMessageFromToken(
                    targetId,
                    "or"
                  ) +
                  " ";
              }
              else if (i + 2 < data.length) {
                string += ", ";
              }
            }

            data = string;
          }

          return message.replace(/{data}/g, data);
        }
      },
      aggregate: function (otherValidationResult = null) {
        if (
          otherValidationResult !== null &&
          otherValidationResult.isValid() !== true
        ) {
          _isValid = false;
          for (let i = 0; i < otherValidationResult.messages.length; i++) {
            const existsAt = _messages.indexOf(otherValidationResult.messages[i]);
            if (existsAt < 0 || JSON.stringify(_data[i]) !== JSON.stringify(otherValidationResult.messagesData[i])) {
              _messages.push(otherValidationResult.messages[i]);
              _data.push(otherValidationResult.messagesData[i]);
            }
          }
        }
      },
      render: function (formId, wrapper, validationCanvas) {
        clearValidationResults(validationCanvas);

        if (_isValid !== true) {
          wrapper.classList.add(window.mcb.forms.constants.validation.failureClass);
          for (let i = _messages.length - 1; i >= 0; i--) {
            const message = this.GetMessage(formId, i);
            const messageEl = document.createElement('div');
            messageEl.innerHTML = message;
            messageEl.classList.add(window.mcb.forms.constants.validation.messageClass);
            messageEl.classList.add(window.mcb.forms.constants.validation.messageFailureClass);
            validationCanvas.append(messageEl);

            if (failFast) {
              break;
            }
          }
        }
        else {
          wrapper.classList.add(window.mcb.forms.constants.validation.successClass);
        }
      }
    };
  }

  const clearValidationResults = function (validationCanvas) {
    if (validationCanvas === null) {
      throw new Error("Control is not initialized");
    }

    validationCanvas.classList.remove(window.mcb.forms.constants.validation.failureClass);
    validationCanvas.classList.remove(window.mcb.forms.constants.validation.errorClass);
    validationCanvas.classList.remove(window.mcb.forms.constants.validation.successClass);
    validationCanvas.innerHTML = ""; // Clear previous validation messages
  }

  const validateMaxLength = function (fieldName, value, maxLength) {
    _logger.trace('Validating Max Length for ' + fieldName);

    if (value === "") {
      return new window.mcb.forms.validation.ValidationResult(true);
    }

    if (value.length <= maxLength) {
      return new ValidationResult(true);
    }
    else {
      _logger.trace(fieldName + ' is Violating Max Length', value, maxLength);
      return new ValidationResult(false, "MaxLengthViolation", maxLength);
    }
  };

  const validateMinLength = function (fieldName, value, minLength) {
    _logger.trace('Validating Min Length for ' + fieldName);

    if (value === "") {
      return new window.mcb.forms.validation.ValidationResult(true);
    }

    if (value.length >= minLength) {
      return new ValidationResult(true);
    }
    else {
      _logger.trace(fieldName + ' is Violating Min Length', value, minLength);
      return new ValidationResult(false, "MinLengthViolation", minLength);
    }
  };

  const validateByRegEx = function (fieldName, value, regex, regexErrorToken) {
    _logger.trace('Validating RegEx for ' + fieldName, value, regex, regexErrorToken);

    if (value === "") {
      return new window.mcb.forms.validation.ValidationResult(true);
    }

    let _regex = new RegExp(regex);
    if (_regex.test(value)) {
      return new ValidationResult(true);
    }

    _logger.warn(fieldName + ' is Violating RegEx', value, regex);

    if (regexErrorToken !== null) {
      return new ValidationResult(false, regexErrorToken);
    }

    return new ValidationResult(false, "RegExViolation");
  };

  const validateModulus = function (fieldName, value, modulus, weights, violationToken) {
    _logger.trace('Validating Modulus for ' + fieldName);

    if (value === "") {
      return new window.mcb.forms.validation.ValidationResult(true);
    }

    const result = validateNumbersOnly(fieldName, value, value);

    const requiredLength = weights.length;
    result.aggregate(validateMinLength(fieldName, value, requiredLength));
    result.aggregate(validateMaxLength(fieldName, value, requiredLength));

    let sum = 0;
    for (let i = 0; i < weights.length; i++) {
      sum += weights[i] * parseInt(value[i]);
    }

    if (sum % modulus === 0) {
      if (result.isValid()) {
        return new ValidationResult(true);
      }
    }
    else {
      _logger.trace(fieldName + ' is Violating Modulus', value);
      result.aggregate(new ValidationResult(false, violationToken))
    }

    return result;
  };

  const validateNumbersOnly = function (fieldName, value, min = null) {
    _logger.trace('Validating Numbers Only for ' + fieldName);

    if (value === "") {
      return new ValidationResult(true);
    }

    let result = validateByRegEx(fieldName, value, "^[0-9]+$", "IntegersOnlyViolation", true);
    if (!result.isValid()) {
      _logger.trace(fieldName + ' is Violating Integers Only', value);
      return result;
    }

    const number = new Number(value);
    if (min !== null && number < min) {
      _logger.trace(fieldName + ' is Violating Min Value', value, min);
      result.aggregate(new ValidationResult(false, "MinValueViolation", min));
    }

    return result;
  };

  const validateRequired = function (fieldName, value) {
    _logger.trace('Validating Required for ' + fieldName);

    if (value === "" || value === "[]" || value === null || value === undefined) {
      _logger.trace(fieldName + ' is Violating Required', value);
      return new ValidationResult(false, "NoValueViolation");
    }

    return new ValidationResult(true);
  }

  const validateEmail = function (fieldName, value, errorMessage = null) {
    _logger.trace('Validating Email for ' + fieldName);

    if (value === "") {
      return new window.mcb.forms.validation.ValidationResult(true);
    }

    if (errorMessage === null) {
      errorMessage = "EMailViolation";
    }

    if (value.length > 0) {
      // No @ or repeated @
      let ia = value.indexOf("@");
      if (ia < 0 || value.indexOf("@", ia + 1) > 0) {
        _logger.trace(fieldName + ' is Violating Email Prefix', value);
        return new ValidationResult(false, errorMessage);
      }

      // . after @
      if (value.lastIndexOf(".") < ia) {
        _logger.trace(fieldName + ' is Violating Email TLD', value);
        return new ValidationResult(false, errorMessage);
      }

      // Empty atoms
      let parts = value
        .split("@")
        .join(".")
        .split(".");
      let pl = parts.length;
      let last = pl - 1;
      for (let i = 0; i < pl; i++) {
        if (i === last && parts[i].length === 1) {
          _logger.trace(fieldName + ' is Violating Email TLD Length', value);
          return new ValidationResult(false, errorMessage);
        }

        if (parts[i].length === 0) {
          _logger.trace(fieldName + ' is Violating Email Atoms', value);
          return new ValidationResult(false, errorMessage);
        }
      }

      // special chars
      if (
        value.indexOf(" ") >= 0 ||
        value.indexOf('"') >= 0 ||
        value.indexOf("\\") >= 0
      ) {
        _logger.trace(fieldName + ' is Violating Email Illegal Characters', value);
        return new ValidationResult(false, errorMessage);
      }
    }

    return new ValidationResult(true);
  };

  return _ = {
    ValidationResult: ValidationResult,
    validateRequired: validateRequired,
    validateByRegEx: validateByRegEx,
    validateNumbersOnly: validateNumbersOnly,
    validateModulus: validateModulus,
    validateEmail: validateEmail,
    validateMaxLength: validateMaxLength,
    validateMinLength: validateMinLength,
    clearValidationResults: clearValidationResults
  };
})();
